import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getProfile, vendorLogout } from '../api/vendorApi';
import { VpSpinner } from '../components/VpUI';

const Row = ({ label, value }: { label: string; value?: any }) => (
	<div className='vp-attn-item'>
		<div className='vp-muted' style={{ width: 180, flex: '0 0 180px' }}>
			{label}
		</div>
		<div style={{ fontWeight: 500 }}>{value || '—'}</div>
	</div>
);

const VendorProfile = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [p, setP] = useState<any>(null);
	const [error, setError] = useState('');

	useEffect(() => {
		(async () => {
			try {
				const data = await getProfile();
				setP(data);
			} catch (err: any) {
				setError(err?.apiMessage || 'Could not load your profile.');
			} finally {
				setLoading(false);
			}
		})();
	}, []);

	const doLogout = () => {
		vendorLogout();
		navigate('/vendor-portal/login', { replace: true });
	};

	if (loading) return <VpSpinner />;
	if (error) return <div className='vp-alert vp-alert-error'>{error}</div>;

	return (
		<div className='vp-card vp-card-pad' style={{ maxWidth: 640 }}>
			<div className='vp-row-between' style={{ marginBottom: 10 }}>
				<h3 style={{ margin: 0 }}>My Profile</h3>
				<button
					type='button'
					className='vp-btn vp-btn-danger vp-input-sm'
					onClick={doLogout}>
					Logout
				</button>
			</div>
			<Row label='Vendor Name' value={p?.name} />
			<Row label='Email' value={p?.email} />
			<Row label='Contact No.' value={p?.contact_no} />
			<Row label='GST' value={p?.gst} />
			<Row label='PAN' value={p?.pan} />
			<Row label='Address' value={p?.address} />
			<Row label='Bank Name' value={p?.bankName} />
			<Row label='Bank Account No.' value={p?.bankAccountNo} />
			<Row label='IFSC' value={p?.ifscCode} />
		</div>
	);
};

export default VendorProfile;
